
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quote",
      function () {
        return require("private-next-pages/quote/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quote"])
      });
    }
  